<template>
 <div class="shopping-cart">
     <!-- <hr/> -->
     <div v-if="product_info" class="margin-top-50 pretty-banner">
        <h5 style="font-size:18px;">Same product but different variations</h5>
        <p >if this product has different colours, sizes, etc... no need filling this long form again, go to this product view and set them.</p>
        <p class="center"><i class="fa fa-arrow-right"></i><a :href="product_url">Proceed to this Product's View </a></p>
     </div>
    <div v-if="!product_info" class="cart-ship-info register col-sm-10 contact_form">
       
        <h6>New Post</h6>
            <form>
                <ul class="row">
                 
                    <li class="col-sm-12">
                        <label> *Title
                            <input type="text" v-model="post.post_title" value="" placeholder="">
                        </label>
                    </li>
                    
                   
                    <li class="col-md-12">
                          <label> *Post
                            <textarea  v-model="post.post_text"></textarea>
                          </label>
                    </li>
                    <!-- <h6>Add a product Item, you can add more items later</h6> -->
                
                    
                    <li class="col-md-12">
                        <p class="p-tiny-info">{{max_media_info}}</p>
                        <div class="upload-btn-wrapper" style="cursor:pointer">
                             <!-- <img class="img_responsive"/> -->
                            <button type="button" class="upload-btn">Add Image / Video</button>
                            <!-- <input type="file" id="input-file" @change="onFileChange($event)" accept="image/*"/> -->
                            <!-- <input type="file" id="input-file" @change="onFileChange($event)" accept="media_type"/> -->
                            <input type="file" id="input-file" @change="onFileChange($event)" accept="video/*,image/*" capture/>
                            <span v-if="file_info[0]"><b>Added {{file_info[0].name}}</b></span>                                                                                                                                                                                                                                                                                                                                        
                        </div>
                        <p class="data-error-message">{{data_media_error_message}}</p>
                    </li>
                    <li class="col-md-6">
                        <p class="data-error-message">{{data_error_message}}</p>
                        <p class="data-success-message">{{data_success_message}}</p>
                        <div v-if="action_loading" class="loading-sm"></div>
                        <button :disabled="disable_btn" type="button" class="btn" @click="addPost">Post</button>
                    </li>
                </ul>
        </form>
        </div>
    </div>
</template>
<style>
.pretty-banner{
   border: 1px solid #b3b9c0;
   padding: 1.2em;
   background: #83ee91;
   line-height: 1.8;
   border-radius: 5px;
   color:#fff; 
}
.pretty-banner p a:hover{
    color: #ff0000;
}
  /*form*/
  .contact_form li {
	text-align: left;
	margin-bottom: 10px;
}
.contact_form li input {
	display: inline-block;
	width: 100%;
	height: 35px;
	padding: 0 10px;
	margin-top: 5px;
}
.contact_form li .error {
	border: 1px solid #CCC;
	border-bottom: 1px solid red;
}
.contact_form li .form-control {
	height: 45px;
	border: 1px solid #2d3a4b;
	box-shadow: none;
	border-radius: 0px;
	background: #fff;
}
.contact_form li textarea {
	height: 140px !important;
	width: 340px;
	margin-top: 10px;
}
.contact_form li .btn {
	text-transform: uppercase;
	padding: 0px 40px;
	height: 45px;
	line-height: 45px;
	font-size: 14px;
	margin-top: 15px;
}
.contact_form li .btn:hover {
	background: #ffffff;
}
.contact-form .tittle {
	text-align: center;
}
.contact-form .tittle hr {
	width: 28px;
	height: 5px;
	margin: 15px auto;
	background: #448aff;
	border: none;
}
.contact-form .tittle p {
	text-transform: none;
	font-size: 16px;
}
.contact-form label {
	font-weight: normal;
	color: #2d3a4b;
	font-size: 12px;
	text-transform: uppercase;
	display: inline-block;
	width: 100%;
	margin: 0px;
	margin-bottom: 13px;
}
.contact-form textarea {
	display: inline-block;
	width: 100%;
	position: relative;
	padding: 10px 20px;
}

</style>

<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'ProductForm',
    data () {
        return {
            user:{},
            sellpoint: {},
            sellpoint_categories: {},
            sub_categories: {},
            post:{},
            product_item: {},
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {},
            action_loading:false,
            data_error_message:"",
            data_success_message:"",
            data_media_error_message:"",
            max_media_info:service.max_upload_image_info,
        }
    },
    components: {
       
    },
    methods: {
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        setComponent(attr1,attr2){
            this.setPanel = true;
            if(attr1 == 'create-sellpoint'){
                this.createSellpointPanel= true;
                this.addProductPanel = false;
                this.addProductItemPanel = false;
            }
            if(attr1 == 'add-product'){
                this.addProductPanel = true;
                this.addProductItemPanel = false;
                this.createSellpointPanel= false;
            }
            if(attr1 == 'add-product-item'){
                this.addProductItemPanel = true;
                this.addProductPanel = false;
                this.createSellpointPanel= false;

            }
        },
        
        trackevent(e){
            // $('#category-type-3').disabled = true;
            if(e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined){
              this.category_type_2 = true;
              this.category_type_3 = true;
            }
            else if(e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined){
              this.category_type_1 = true;
              this.category_type_3 = true;
            }
            else if(e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined){
              this.category_type_1 = true;
              this.category_type_2 = true; 
            }
            else{
            this.category_type_1 = false;
              this.category_type_2 = false;
              this.category_type_3 = false;
             }
        },

        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        //get sellpoint categories
                        this.getSellpointCategories();

                    }else {
                        this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
        },

        getSellpointCategories(){
            service.getBusinessByUserName(this, this.$route.params.id).then(response => {
                if(response.body.status == 200) {
                   this.sellpoint = response.body.data;
                   //let sellpoint_data = response.body.data;
                    service.getBusinessCategories(this, this.sellpoint.business_id).then(response => {
                        if(response.body.status == 200) {
                            this.sellpoint_categories = response.body.data;
                        }
                    }).catch((err) => {})
                    this.getSubCategories(this.sellpoint.business_category_id);
                }
            }).catch((err) => {
                //log it
               // this.$router.push("/")
               console.log(err)
            })

        },

        getSubCategories(category){
            service.getBusinessSubCategories(this, category).then(response => {
                if(response.body.status == 200) {
                    this.sub_categories = response.body.data;
                }
            }).catch((err) => {})
                
        },

        addPost(){
            // this.disable_btn = true;
            this.activate_processing();
            //this.business.agree = true;
            var credentials = {
                post_title: this.post.post_title || "nill",
                post_text: this.post.post_text,
                post_point: this.sellpoint.business_id,
                post_product: 0, //revive
            }
            
            let navi = this.$router;
            if(credentials.post_text != undefined) {
                service.addPost(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        toastr.success("Post Created", 'Success!');
                        this.data_success_message =  "Post Created";
                        //log user in
                        this.post = data.body.data;
                        
                        //add image
                        //let result = data.body.data;
                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type","default_post_media");
                        let url = "/"+this.$route.params.id+"/p/"+this.post.post_url_name; 
                        service.uploadDataPhoto(this, this.imageForm).then(data => {
                        if(data.body.status == 200){
                            this.data_media_error_message = "";
                            location.replace(url); //changed for now, info on banner
                        }
                        }).catch((err) => {
                                if(err) {
                                // log it
                                // console.log(err)
                                }
                            toastr.warning("Something went wrong.", 'Warning!');
                            this.data_error_message =  "Something went wrong.";
                        })
                        //if uploading takes time continue with reload
                        this.data_media_error_message = service.media_upload_timeout_msg;
                        let self = this;
                        setTimeout(function(){  self.data_media_error_message; }, 1200); //wait for 1min and timeout
                        setTimeout(function(){  location.replace(url);  }, 2000); //wait for 1min and timeout
                        this.deactivate_processing();
                    }else{
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    if(err) {
                        this.deactivate_processing();
                        toastr.warning("Something went wrong", 'Warning!'); 
                        this.data_error_message = "Something went wrong.";
                        // console.log(err)
                        // this.disable_btn = false;
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.data_error_message =  "Kindly fill all fields";
                // this.disable_btn = false;
                this.deactivate_processing();
            }
        },

        //uploads
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {   
                this.file_info = files;
                let formData = new FormData();
                formData.append('photo', files[0]); 
                this.imageForm = formData;
            }   
        
        },

},
    created: function(){
        this.preset();
    }
}

</script>


// WEBPACK FOOTER //
// newpost.vue?e9256cca